/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of Merative                         */
/*                                                                   */
/* (C) Copyright Merative Corp. 2025                                 */
/*                                                                   */
/* ***************************************************************** */
import React from "react";

import {useHistory} from "react-router-dom";
import TabbedContainer from "../../../../components/common/TabbedContainer";
import {makeSetDisplayChoiceAction} from "../../pages/EnteralFormulas/SearchPage/redux/formula_search_redux";
import {useDispatch} from "react-redux";
import {
  DRUG_MONOGRAPHS_TAB_NAME, ENTERAL_FORMULA_TAB_NAME,
  FORMULA_SEARCH_PANEL_NAME,
  NEOFAX_FORMULA_PICKLIST_ID, NEOPED_URL,
  PEDIATRICS_FORMULA_PICKLIST_ID,
  PER_100_CAL, RESULT_TYPE_NEOFAX, SECTION_TYPE_DRUGS, SECTION_TYPE_FORMULAS
} from "../constants";
import {
  makeSetSearchTextAction,
  makeClearSelectedItemsAction,
} from "mdx-ivcomp-common-ui/dist/src/components/ivpicklist/iv-picklist-redux/iv-picklist-redux";

export const SectionTabsForNavigation = ({selectedIndex = 1}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const makeDefaultPageState = () => {
    dispatch(makeSetDisplayChoiceAction(PER_100_CAL));
    dispatch(makeSetSearchTextAction("", NEOFAX_FORMULA_PICKLIST_ID, FORMULA_SEARCH_PANEL_NAME));
    dispatch(makeSetSearchTextAction("", PEDIATRICS_FORMULA_PICKLIST_ID, FORMULA_SEARCH_PANEL_NAME));
    dispatch(makeClearSelectedItemsAction(NEOFAX_FORMULA_PICKLIST_ID, FORMULA_SEARCH_PANEL_NAME));
    dispatch(makeClearSelectedItemsAction(PEDIATRICS_FORMULA_PICKLIST_ID, FORMULA_SEARCH_PANEL_NAME));
  }

  const sectionTypeTabs = [
    {
      label: DRUG_MONOGRAPHS_TAB_NAME,
      onClick: () => history.push(`${NEOPED_URL}?section=${SECTION_TYPE_DRUGS}&tab=${RESULT_TYPE_NEOFAX}`)
    },
    {
      label: ENTERAL_FORMULA_TAB_NAME,
      onClick: () => {
        history.push(`${NEOPED_URL}?section=${SECTION_TYPE_FORMULAS}&tab=${RESULT_TYPE_NEOFAX}`);
        makeDefaultPageState();
      }
    }
  ];

  return <div data-testid="section-tabs">
    <TabbedContainer
      tabs={sectionTypeTabs}
      defaultSelectedIndex={selectedIndex}
      preSelectedIndex={selectedIndex}
      ariaLabel="Drug Monographs and Enteral Formulas tabs"
      className="gray-tabs"
    />
  </div>
}
